import {t}      from "element-ui/src/locale";

export const SelectProps = {
    name: String,
    id: String,
    /**
     * @description binding value
     */
    modelValue: {
        type: [Array, String, Number, Boolean, Object],
        default: undefined,
    },
    autocomplete: {
        type: String,
        default: 'off'
    },
    /** @Deprecated in next major version */
    autoComplete: {
        type: String,
        validator(val) {
            process.env.NODE_ENV !== 'production' &&
            console.warn('[Element Warn][Select]\'auto-complete\' property will be deprecated in next major version. please use \'autocomplete\' instead.');
            return true;
        }
    },
    automaticDropdown: Boolean,
    size: String,
    disabled: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    allowCreate: Boolean,
    loading: Boolean,
    popperClass: String,
    remote: Boolean,
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    remoteMethod: Function,
    filterMethod: Function,
    multiple: Boolean,
    multipleLimit: {
        type: Number,
        default: 0
    },
    placeholder: {
        type: String,
        required: false
    },
    defaultFirstOption: Boolean,
    reserveKeyword: Boolean,
    valueKey: {
        type: String,
        default: 'value'
    },
    collapseTags: Boolean,
    popperAppendToBody: {
        type: Boolean,
        default: true
    }
}
export const TreeProps = {
    data: {
        type: Array,
        default: ()=> []
    },
    emptyText: {
        type: String,
        default() {
            return t('el.tree.emptyText');
        }
    },
    renderAfterExpand: {
        type: Boolean,
        default: true
    },
    nodeKey: {
        type: String,
        default: "value"
    },
    checkStrictly: Boolean,
    defaultExpandAll: Boolean,
    expandOnClickNode: {
        type: Boolean,
        default: true
    },
    checkOnClickNode: Boolean,
    checkDescendants: {
        type: Boolean,
        default: false
    },
    autoExpandParent: {
        type: Boolean,
        default: true
    },
    defaultCheckedKeys: Array,
    defaultExpandedKeys: Array,
    currentNodeKey: [String, Number],
    renderContent: Function,
    showCheckbox: {
        type: Boolean,
        default: false
    },
    draggable: {
        type: Boolean,
        default: false
    },
    allowDrag: Function,
    allowDrop: Function,
    props: {
        default() {
            return {
                children: 'children',
                label: 'label',
                disabled: 'disabled'
            };
        }
    },
    lazy: {
        type: Boolean,
        default: false
    },
    highlightCurrent: Boolean,
    load: Function,
    filterNodeMethod: Function,
    accordion: Boolean,
    indent: {
        type: Number,
        default: 18
    },
    iconClass: String
}
